import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
const Input = ({ type, placeholder, id, name, labelText, handfunc, func, cstyle, cRef }) => {

    const [eye, setEye] = useState(false);
    const indputDivStyle = {
        position: "relative",
        InputStyle: {
            width: "100%",
            padding: "7px 5px",
            marginTop: "10px",
            fontSize: "20px",
            borderRadius: "5px",
            outline: "none",
            // ...cstyle
        },
        labelStyle: {
            color: "#fff",
        },
        ibutton: {
            position: "absolute",
            top: "calc(50% + 5px)",
            right: 0,
            transform: "translate(0, -50%)",
            cursor: "pointer",
            icon: {
                color: "#565656"
            }
        }
    }

    const handleClickButton = () => {
        setEye(!eye)
    }

    return (
        <>
            {indputDivStyle.labelStyle && <label style={indputDivStyle.labelStyle} htmlFor={id} >{labelText}</label>}
            <div style={indputDivStyle}>
                <input
                    ref={cRef}
                    onClick={func.click}
                    className="inputbox"
                    style={indputDivStyle.InputStyle}
                    onChange={func.change}
                    type={type === "password" ? eye ? "text" : type : type}
                    placeholder={placeholder}
                    id={id}
                    name={name}
                    onInput={handfunc} />
                {
                    type === "password" &&
                    <div style={indputDivStyle.ibutton} onClick={handleClickButton}>
                        <FontAwesomeIcon style={indputDivStyle.ibutton.icon} icon={eye ? faEye : faEyeSlash} />
                    </div>
                }
            </div>
        </>
    );
}

export default Input;